import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import { toast } from 'react-toastify';

// Validation Schema using Yup
const schema = yup.object().shape({
  email: yup
    .string()
    .email('Enter a valid email')
    .required('Email is required'),
});

const ForgotPassword = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: '',
    },
  });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const response = await postData(end_points.forgotPassword.url, data);
      if (response.status == 200 || response.status == 201) {
        toast.success('Verification mail sent');
      }
    } catch (error) {
      error?.data?.email && toast.error(error?.data?.email[0]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="user-login-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="ui-dash tab-content mar-bot-30">
              <div
                className="tab-pane fade show active"
                id="login"
                role="tabpanel"
              >
                <div className="card-box">
                  <div className="card-header">
                    <h2>Forgot Password</h2>
                  </div>
                  <form id="login-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>Email Address</label>
                      <Controller
                        name="email"
                        control={control}
                        render={({ field }) => (
                          <input
                            {...field}
                            type="text"
                            id="email"
                            className="form-control"
                          />
                        )}
                      />
                      {errors.email && (
                        <small className="text-danger">
                          {errors.email.message}
                        </small>
                      )}
                    </div>

                    <div className="form-group mb-0">
                      <div className="text-center">
                        <button
                          type="submit"
                          id="login-submit"
                          className="button style1"
                          disabled={loading}
                        >
                          {loading ? 'Verifying...' : 'Verify'}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
